import React from "react";

class LOLout extends React.Component {
    render() {
      const styles={
        blackbg: {
          backgroundColor: "#121212"
        },
        blueText:{
          color: "#037ef3"
        }
      }

      return <div className="w-full h-full text-white" style={styles.blackbg}>
            <div className="w-full max-w-2xl m-auto py-8 px-4">
                <div className="text-xl" style={styles.blueText}>AIESEC in SLIIT</div>
                <div className="text-4xl font-bold">oGT PS - Leadership Body - Round 2</div>
                <div className="text-xl mt-1 text-gray-400">Application Package</div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Timeline</div>
                  <div>
                    <span className="font-bold">Application Open - </span> <span className="text-gray-300">25th June</span> <br/>
                    <span className="font-bold">Application Deadline - </span> <span className="text-gray-300">27th June 11:59 PM</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Team Structure</div>
                  <div>
                    <span className="font-bold">Members</span> <span className="text-gray-400"> x16</span> <br/>
                    <span className="font-bold">Team Leaders</span> <span className="text-gray-400">x4</span> <br/>
                    <span className="font-bold">Members per TL</span> <span className="text-gray-400">x3</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Available Roles</div>
                  <br/>

                  
                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #0373f3" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#0373f3" }}>Team Leader</div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Create IR Partnerships with entities abroad</li>
                        <li>Maintain Contact with the IR partners</li>
                        <li>Have a good synergy with the oGT B2C team and provide them with the projects</li>
                        <li>Provide the Marketing Team with the project content of the Partners</li>
                        <li>Downscaling the strategies/action plans communicated by the LCVP/OEVP</li>
                        <li>Maintaining real-time IR trackers as advised by the LCVP/OEVP</li>
                        <li>Maintaining member delegation and engagement</li>
                        <li>Accountability towards team performance</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">KPIs</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li># of APP</li>
                        <li># of APD</li>
                        <li># of RE</li>
                        <li># of FIN</li>
                        <li># of CO</li>
                        <li># of IR</li>
                      </ul>
                    </div>
                  </div>
                  <br />

                 

                {/** Contact Info ***/}
                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-4 font-semibold">Contact Info</div>
                  <div>
                    <div >For any clarifications, </div> 
                    <div style={styles.blueText} className="text-3xl">Pasindu Gunasekara</div> 
                    <div className="text-gray-400">OEVP oGT PS – AIESEC in SLIIT</div>
                    <div className="text-gray-400">pasindu.gunasekara@aiesec.net</div>
                    <div className="text-gray-400">+94 76 623 4615</div>
                    
                  </div>
                </div>

                

                <a href="https://docs.google.com/forms/d/e/1FAIpQLSeHNrYr-FFkydetOWBhLYdZn3Hvxenkh5ZJ3dcNsoCA7eP3Lg/viewform?usp=sf_link" target="_blank" rel="noreferrer">
                <div className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{"background": "#037ef3"}}>
                  Apply
                </div>
                </a>

                </div>
            </div>
      </div>;
    }
  }

export default LOLout